module.exports = __webpack_public_path__ + "static/media/selectfilter.650b1dd4.svg";